import { Configuration, PublicClientApplication, AccountInfo } from '@azure/msal-browser'

// MSAL configuration
const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    allowRedirectInIframe: true,
    windowHashTimeout: Number(import.meta.env.VITE_MSAL_WINDOW_HASH_TIMEOUT) || 60000,
    iframeHashTimeout: Number(import.meta.env.VITE_MSAL_IFRAME_HASH_TIMEOUT) || 6000,
    loadFrameTimeout: 0,
    navigateFrameWait: 0,
  },
}

// Login request object
export const loginRequest = {
  scopes: [import.meta.env.VITE_MSAL_API_SCOPE || 'api://c8807421-fe6a-4bb2-9108-9220ffd3679d/access_as_user'],
}

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig)

// Track initialization state
let _msalInitialized = false
export const getMsalInitialized = () => _msalInitialized
export const setMsalInitialized = (value: boolean) => { _msalInitialized = value }

export const getActiveAccount = (): AccountInfo | null => {
  if (!_msalInitialized) {
    console.warn('MSAL is not yet initialized')
    return null
  }
  const activeAccounts = msalInstance.getAllAccounts()
  if (activeAccounts.length === 0) return null
  return activeAccounts[0]
}

export const signIn = async () => {
  if (!_msalInitialized) {
    throw new Error('MSAL is not yet initialized')
  }
  try {
    const response = await msalInstance.loginPopup(loginRequest)
    if (response) {
      msalInstance.setActiveAccount(response.account)
      return response.account
    }
  } catch (error) {
    console.error('Error during sign in:', error)
    throw error
  }
}

export const signOut = async () => {
  if (!_msalInitialized) {
    throw new Error('MSAL is not yet initialized')
  }
  const account = getActiveAccount()
  if (account) {
    await msalInstance.logoutPopup({
      account,
      postLogoutRedirectUri: window.location.origin,
    })
  }
}

export const getAccessToken = async (): Promise<string | null> => {
  if (!_msalInitialized) {
    throw new Error('MSAL is not yet initialized')
  }
  const account = getActiveAccount()
  if (!account) return null

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    })
    return response.accessToken
  } catch (error) {
    // If silent token acquisition fails, try to get token using popup
    try {
      const response = await msalInstance.acquireTokenPopup({
        ...loginRequest,
        account,
      })
      return response.accessToken
    } catch (error) {
      console.error('Error acquiring token:', error)
      return null
    }
  }
}
